module.exports = __webpack_public_path__ + "img/speaker-7.908f115d.jpg";